import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <footer class="footer bg-dark">
        <div class="container mt-5 p-5">
            <div class="row">
                <div class="col-md-3 p-3">
                    <h6>Information for</h6>
                    <ul class="list-group footer-list border-0">
                        <li class="list-group-item border-0"><small>Prospective undergraduates</small></li>
                        <li class="list-group-item border-0"><small>Prospective graduates students</small></li>
                        <li class="list-group-item border-0"><small>Bussinesses/Partnerships</small></li>
                        <li class="list-group-item border-0"><small>Visitors/Tourists</small></li>
                        <li class="list-group-item border-0"><small>Parliamentarians</small></li>
                    </ul>
                </div>
                <div class="col-md-3 p-3">
                    <h6>Quick Links</h6>
                    <ul class="list-group footer-list border-0">
                        <li class="list-group-item border-0"><small>Prospective undergraduates</small></li>
                        <li class="list-group-item border-0"><small>Prospective graduates students</small></li>
                        <li class="list-group-item border-0"><small>Bussinesses/Partnerships</small></li>
                        <li class="list-group-item border-0"><small>Visitors/Tourists</small></li>
                        <li class="list-group-item border-0"><small>Parliamentarians</small></li>
                    </ul>
                </div>
                <div class="col-md-3 p-3">
                    <h6>Information About</h6>
                    <ul class="list-group footer-list border-0">
                        <li class="list-group-item border-0"><small>Prospective undergraduates</small></li>
                        <li class="list-group-item border-0"><small>Prospective graduates students</small></li>
                        <li class="list-group-item border-0"><small>Bussinesses/Partnerships</small></li>
                        <li class="list-group-item border-0"><small>Visitors/Tourists</small></li>
                        <li class="list-group-item border-0"><small>Parliamentarians</small></li>
                    </ul>
                </div>
                <div class="col-md-3 p-3">
                    <h6>Security Brand</h6>
                    <ul class="list-group footer-list border-0">
                        <li class="list-group-item border-0"><small>Prospective undergraduates</small></li>
                        <li class="list-group-item border-0"><small>Prospective graduates students</small></li>
                        <li class="list-group-item border-0"><small>Bussinesses/Partnerships</small></li>
                        <li class="list-group-item border-0"><small>Visitors/Tourists</small></li>
                        <li class="list-group-item border-0"><small>Parliamentarians</small></li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
    );
};

export default Footer;